import React, { FC, useState } from 'react'
import { useLocalization } from '@components/Localization'
import { updateCookieSettings } from '@lib/cookies'
import { Box, Heading, Text, linkStyles, breakpoints, Button, CleanButton } from '@gassan-ui'
import styled from 'styled-components'
import Modal from './Modal'

const Container = styled(Box)`
  z-index: ${p => p.theme.zIndices.cookieNotice};
`

const ShowSettings = styled(CleanButton)`
  ${linkStyles};
  margin-top: 1rem;
  margin-bottom: 0.5rem;

  @media screen and (min-width: ${breakpoints.large}) {
    margin-bottom: 1rem;
  }
`

const Notice: FC = () => {
  const [isCookiePopupVisible, setIsCookiePopupVisible] = useState(false)
  const { messages } = useLocalization()

  const acceptAll = () => {
    updateCookieSettings(['personal', 'analytical', 'functional'])
    window.location.reload()
  }
  return (
    <>
      <Container
        boxShadow={['initial', '0 1rem 1.25rem rgba(0, 0, 0, 0.05)']}
        position="fixed"
        left={{ _: 0, small: '2rem', large: '3rem', xxlarge: '5.5rem' }}
        right={[0, 'initial']}
        bottom={{ _: '1.5rem', small: '2rem', large: '3rem', xxlarge: '5.5rem' }}
        width="100%"
        borderTopColor="bigStone"
        borderTopWidth={['1px', '2px']}
        borderTopStyle="solid"
        maxWidth={['calc(100% - 2rem)', '23rem']}
        p={['1.25rem', '2rem']}
        bg="pampasLight"
        m={['0 auto', 'initial']}
      >
        <Heading mb={{ _: '0.5rem', small: '1rem' }} variant="h5">
          {messages.cookies.noticeTitle}
        </Heading>
        <Text color="shades.600" variant="micro">
          {messages.cookies.noticeMsg}
          <ShowSettings onClick={() => setIsCookiePopupVisible(true)}>
            {messages.cookies.noticeMsgSettings}
          </ShowSettings>
        </Text>
        <Button variant="dark" minWidth="100%" onClick={() => acceptAll()}>
          {messages.cookies.acceptAll}
        </Button>
      </Container>
      {isCookiePopupVisible && <Modal onClose={() => setIsCookiePopupVisible(false)} />}
    </>
  )
}

export default Notice
